export const formatSubscriber = (str) => {
  return str;
};
